module.exports = __webpack_public_path__ + "static/media/phone_book.a33512de.svg";